// Página centralizada de excursiones con Timeline y scroll-snap
import React, { useRef, useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Box,
  Typography,
  Button,
  useMediaQuery,
  useTheme,
  MobileStepper,
  Fab,
  IconButton,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { keyframes } from '@mui/system';

import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
} from "@mui/lab";
import { useNavigate } from "react-router-dom";
import logo from "../images/Recurso.svg";

const pulse = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

const excursiones = [
  {
    id: "atuel",
    titulo: "Cañón del Atuel",
    descripcion:
      "Recorrido completo en van o minibús por el Cañón del Atuel. Paisajes de lagos, río y montañas. Día completo de duración, con tiempo para actividades en Valle grande.",
    precio: "$53.000 ",
    dias: "Martes, Viernes y Domingos",
    bg: "https://static.wixstatic.com/media/nsplsh_cc709f3388e64e80bf3c262933b72c05~mv2.jpg",
    incluye: ["traslado. sale y llega al hostel. guía y acceso a pileta."],
    noIncluye: ["Comidas, entradas, actividades adiconales"],
    recorrido:
      "Cuesta de los terneros – Sierra Pintada - Dique y Lago El Nihuil – Cañón del Atuel – Valle Grande",
  },
  {
    id: "vinos",
    titulo: "Caminos del Vino",
    descripcion:
      "Medio día recorriendo 3 bodegas locales por los hermosos paisajes del sur de Mendoza.",
    precio: "$46.000",
    dias: "Martes, Jueves y Sábados",
    bg: "https://sanrafaelturismo.gov.ar/wp-content/uploads/2022/03/Copia-de-Vinedos-en-la-Cuesta-scaled.jpg",
    incluye: ["Traslado, entradas y degustación."],
    noIncluye: [],
    recorrido: "",
  },
  {
    id: "borges",
    titulo: "Laberinto de Borges",
    descripcion:
      "City tour por San Rafael y visita al famoso laberinto homenaje a Borges.",
    precio: "$46.000",
    dias: "Martes y Jueves",
    bg: "https://cloudfront-us-east-1.images.arcpublishing.com/artear/SPKOGJLD7NCPZOPND6VOU7BFFI.jpg",
    incluye: ["traslado, guía y entrada."],
    noIncluye: [],
    recorrido:
      "Catedral San Rafael Arcángel - Plaza San Martin - Parque Hipólito Irigoyen - Plaza Francia - Laberinto de Borges",
  },
  {
    id: "sabores",
    titulo: "Sabores Cuyanos",
    descripcion:
      "Recorrido por las zonas productivas de San Rafael y bodegas boutique. Almuerzo en resto o bodega (según disponibilidad) maridado con exquisitos vinos. Día completo de duración (de 09:00hs a 15:00hs). RESERVA MÍNIMA 2 PERSONAS.",
    precio: "$185.000 (2P)",
    dias: "Viernes",
    bg: "https://destinosanjuan.com.ar/wp-content/uploads/2020/07/20200711_172521.jpg",
    incluye: [
      "Traslado, entrada, recorridos por los viñedos, cata dirigida, almuerzo menú 3 pasos, agua y copas de vino.",
    ],
    noIncluye: [],
    recorrido: "",
  },
  {
    id: "lamansa",
    titulo: "Bodega La Mansa",
    descripcion:
      "Recorrido guiado a través de la bodega y el proceso productivo. Cata de 5 etiquetas guiada por enólogos, acompañadas de un tapeo y un atardecer inolvidable. Medio día de duración (de 18:30 a 21:30hs).RESERVA MÍNIMA: 2 PERSONAS.",
    precio: "$176.000 (2P)",
    dias: "Jueves o Sábados",
    bg: "https://d2r9epyceweg5n.cloudfront.net/stores/001/625/807/rte/imagen%20brindis%20personas.jpg",
    incluye: ["Traslado ida y vuelta al Hostel. Entrada, degustación y tapeo."],
    noIncluye: [],
    recorrido: "",
  },
  {
    id: "laslenas",
    titulo: "Valle Las Leñas",
    descripcion:
      "Recorrido en van o minibús por el corazón de la cordillera, visitando increíbles formaciones geológicas y paraísos naturales. Día completo (de 08:30hs a 19:00hs).",
    precio: "$82.000",
    dias: "Miércoles y Sábados",
    bg: "https://larutanatural.gob.ar/panel/public/uploads/rutas-naturales/generated/w1800,h1253,fcrop,q80/76d41dc7-cfa9-42bf-bede-5fb122ef4e0c.jpg",
    incluye: ["Traslado. Sale y regresa al hostel. Servicio de guía."],
    noIncluye: ["Comidas, entradas, actividades opcionales."],
    recorrido:
      "Salinas del Diamante - El Sosneado - Mirador del Infiernillo - Laguna de La Niña Encantada - Pozo de las Ánimas - Valle de las Leñas",
  },
  {
    id: "losreyunos",
    titulo: "Los Reyunos",
    descripcion:
      "Recorrido en van o minibús por el área fundacional de San Rafael y lagos cercanos. Con tiempo para actividades adicionales como la tirolesa más larga del país. Medio día de duración (de 14:00hs a 19:30hs).",
    precio: "$33.000 ",
    dias: "Lunes, Jueves y Sábados",
    bg: "https://upload.wikimedia.org/wikipedia/commons/f/f0/Los_Reyunos.jpg",
    incluye: [
      "TRASLADO. SALE Y REGRESA AL HOTEL. ENTRADA A BODEGAS Y DEGUSTACIÓN.",
    ],
    noIncluye: ["COMIDAS, ENTRADAS, ACTIVIDADES OPCIONALES."],
    recorrido:
      "Villa 25 de Mayo - Dique Galileo Vitale - Dique y lago Los Reyunos - Fábrica local con degustación",
  },
];

function ExcursionesPage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const refs = useRef({});
  const [activeStep, setActiveStep] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = excursiones.findIndex(
              (e) => e.id === entry.target.id
            );
            if (index !== -1) setActiveStep(index);
          }
        });
      },
      { threshold: 0.6 }
    );
    excursiones.forEach((exc) => {
      const el = refs.current[exc.id];
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  const scrollToSection = (id) => {
    refs.current[id]?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Box>

      {/* AppBar fija */}
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: "#ebe4d2",
          color: "black",
          px: 2,
          py: 1,
        }}
        elevation={1}
      >
        <Toolbar
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
            cursor: { xs: "pointer", sm: "default" },
          }}
          onClick={() => {
            if (isMobile) navigate("/");
          }}
        >
          <Box
            component="img"
            src={logo}
            alt="Hostel Privilegio"
            sx={{
              height: 55,
              cursor: "pointer",
              px: 10,
              display: { xs: "none", sm: "block" },
            }}
            onClick={(e) => {
              e.stopPropagation(); // evita que al hacer click en el logo también se dispare el onClick del Toolbar
              navigate("/");
            }}
          />
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: "bold",
              textAlign: "center",
              flex: 1,
              ml: { xs: 0, sm: -5 },
              fontSize: "1.2rem",
            }}
          >
            EXCURSIONES TURÍSTICAS (10% OFF A TRAVÉS DE LA WEB)
          </Typography>
        </Toolbar>
      </AppBar>
{/* Botón flotante "Reservar habitaciones" */}
<Box
  sx={{
    position: "fixed",
    bottom: 24,
    right: 24,
    zIndex: 1100,
    display: { xs: "none", sm: "flex" },
    flexDirection: "column",
    alignItems: "flex-end",
  }}
>
<Typography
  variant="body2"
  sx={{
    mb: 1,
    fontSize: "1rem",
    fontWeight: "bold",
    color: "#fff",
    textTransform: "uppercase",
    textShadow: "2px 2px 2px rgba(0, 0, 0, 0.6)",
  }}
>
  ¿Ya reservaste?
</Typography>

  <Button
    variant="contained"
    onClick={() => navigate("/")}
    sx={{
      background: "linear-gradient(270deg, #DD8362, #2F4D48, #C08936)",
      backgroundSize: "600% 600%",
      animation: `${pulse} 2.5s ease infinite`,
      color: "#fff",
      fontSize: "0.95rem",
      fontWeight: "bold",
      letterSpacing: "0.1rem",
      textTransform: "uppercase",
      borderRadius: 2,
      px: 3,
      py: 2,
      boxShadow: "3px 6px 5px rgba(0, 0, 0, 0.25)",
      transition: "transform 0.2s ease-in-out",
      "&:hover": {
        transform: "scale(1.08)",
        boxShadow: "3px 6px 10px rgba(0, 0, 0, 0.8)",
      },
    }}
  >
    Reservar habitaciones
  </Button>
</Box>
      {/* Contenedor principal */}
      <Box
        sx={{
          display: "flex",
          pt: 8,
          height: "100vh",
          overflowY: "scroll",
          scrollSnapType: "y mandatory",
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        {/* Timeline lateral */}
        {!isMobile && (
          <Box
            sx={{
              width: "20%",
              backgroundColor: "#ebe4d2",
              p: 2,
              position: "sticky",
              top: 0,
              height: "100%",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                textAlign: "center",
                fontWeight: "bold",
                color: "#2F4D48",
                letterSpacing: "0.05em",
                textTransform: "uppercase",
                fontSize: "1.05rem",
                borderBottom: "2px solid #C08936",
                pt: 2,
                mx: 1,
              }}
            >
              Recorré las experiencias
            </Typography>
            <Timeline position="alternate">
              {excursiones.map((exc, index) => (
                <TimelineItem key={exc.id}>
                  <TimelineSeparator>
                    <TimelineDot
                      onClick={() => scrollToSection(exc.id)}
                      sx={{
                        cursor: "pointer",
                        backgroundColor:
                          activeStep === index ? "#00FF7F" : "#16A357", // Verde lima para activo
                        transition: "all 0.3s ease-in-out",
                        transform:
                          activeStep === index ? "scale(1.3)" : "scale(1)",
                        boxShadow:
                          activeStep === index ? "0 0 10px #00FF7F" : "none",
                        "&:hover": {
                          backgroundColor:
                            activeStep === index ? "#00cc66" : "#117c42",
                        },
                      }}
                    />
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent>
                    <Typography
                      onClick={() => scrollToSection(exc.id)}
                      sx={{
                        cursor: "pointer",
                        fontSize: "0.9rem",
                        fontWeight: activeStep === index ? "bold" : "normal",
                        color: activeStep === index ? "#000" : "inherit",
                        transition: "all 0.2s ease",
                      }}
                    >
                      {exc.titulo}
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
              ))}
            </Timeline>
          </Box>
        )}

        <Box sx={{ width: "100%", flexGrow: 1 }}>
          {excursiones.map((exc, index) => (
            <Box
              key={exc.id}
              id={exc.id}
              ref={(el) => (refs.current[exc.id] = el)}
              sx={{
                height: "100vh",
                scrollSnapAlign: "start",
                backgroundImage: `url(${exc.bg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "center",
                position: "relative",
                px: 3,
                pt: { xs: "12vh", md: "18vh" },
              }}
            >
              <Box
                sx={{
                  backgroundColor: "rgba(0, 0, 0, 0.7)",
                  p: { xs: 3, md: 4 },
                  borderRadius: 3,
                  color: "#fff",
                  textAlign: "center",
                  maxWidth: "600px",
                  backdropFilter: "blur(10px)",
                  boxShadow: "0 8px 24px rgba(0,0,0,0.3)",
                  position: "relative",
                }}
              >
                <Typography
                  variant="h4"
                  gutterBottom
                  sx={{
                    fontWeight: "bold",
                    fontSize: { xs: "1.6rem", md: "2.2rem" },
                  }}
                >
                  {exc.titulo}
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { xs: "0.95rem", md: "1.05rem" },
                    mb: 2,
                    lineHeight: 1.6,
                  }}
                >
                  {exc.descripcion}
                </Typography>

                <Typography
                  variant="subtitle1"
                  sx={{ fontSize: "1rem", mb: 3 }}
                >
                  <strong>💰 Precio:</strong> {exc.precio} &nbsp;|&nbsp;{" "}
                  <strong>📅 Días:</strong> {exc.dias}
                </Typography>
                {exc.recorrido && typeof exc.recorrido === "string" && (
                  <Box
                    sx={{
                      textAlign: "left",
                      mt: 2,
                      display: { xs: "none", md: "block" }, // Oculta en mobile
                    }}
                  >
                    <Typography
                      variant="subtitle2"
                      sx={{ fontWeight: "bold", mb: 1 }}
                    >
                      📍 Recorrido:
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ ml: 2, color: "#FFF", mb: 0.5 }}
                    >
                      {exc.recorrido}
                    </Typography>
                  </Box>
                )}
                {exc.incluye && (
                  <Box sx={{ textAlign: "left", mt: 2 }}>
                    <Typography
                      variant="subtitle2"
                      sx={{ fontWeight: "bold", mb: 1 }}
                    >
                      ✅ Incluye:
                    </Typography>
                    {Array.isArray(exc.incluye) ? (
                      exc.incluye.map((item, i) => (
                        <Typography
                          key={i}
                          variant="body2"
                          sx={{
                            ml: 2,
                            color: "#C1FFC1",
                            mb: 0.5,
                            textTransform: "uppercase",
                          }}
                        >
                          • {item}
                        </Typography>
                      ))
                    ) : (
                      <Typography
                        variant="body2"
                        sx={{
                          ml: 2,
                          color: "#C1FFC1",
                          mb: 0.5,
                          textTransform: "uppercase",
                        }}
                      >
                        {exc.incluye}
                      </Typography>
                    )}
                  </Box>
                )}

                {exc.noIncluye && exc.noIncluye.length > 0 && (
                  <Box sx={{ textAlign: "left", mt: 2 }}>
                    <Typography
                      variant="subtitle2"
                      sx={{ fontWeight: "bold", mb: 1 }}
                    >
                      ❌ No incluye:
                    </Typography>
                    {Array.isArray(exc.noIncluye) ? (
                      exc.noIncluye.map((item, i) => (
                        <Typography
                          key={i}
                          variant="body2"
                          sx={{
                            ml: 2,
                            color: "#FFC1C1",
                            mb: 0.5,
                            textTransform: "uppercase",
                          }}
                        >
                          • {item}
                        </Typography>
                      ))
                    ) : (
                      <Typography
                        variant="body2"
                        sx={{
                          ml: 2,
                          color: "#FFC1C1",
                          mb: 0.5,
                          textTransform: "uppercase",
                        }}
                      >
                        {exc.noIncluye}
                      </Typography>
                    )}
                  </Box>
                )}
                <Box
                  display="flex"
                  flexDirection={{ xs: "column", sm: "row" }}
                  justifyContent="center"
                  gap={2}
                  mb={3}
                >
<Button
  variant="contained"
  sx={{
    backgroundColor: "#28614C",
    fontWeight: "bold",
    color: "#FFF",
    px: { xs: 0, md: 5 }, // padding horizontal más chico en mobile
    py: { xs: 1, md: 1.5 }, // padding vertical más chico en mobile
    mt: 1,
    mx: 5,
    fontSize: { xs: "0.95rem", md: "1rem" },
    "&:hover": { backgroundColor: "#117c42" },
  }}
  href={`https://wa.me/542604206967?text=${encodeURIComponent(
    `Hola! Vengo de parte de Hostel Privilegio. Ya revisé los detalles de la excursión "${exc.titulo}". Me gustaría reservarla, ¿podrías ayudarme?`
  )}`}
  target="_blank"
>
  RESERVAR AHORA
</Button>
                </Box>

                {/* Botones dentro de cada card */}
<Box
  display="flex"
  justifyContent="space-between"
  mt={2}
  sx={{ position: "absolute", bottom: 16, left: 16, right: 16 }}
>
  {isMobile ? (
    <>
      <IconButton
        disabled={index === 0}
        onClick={() =>
          scrollToSection(excursiones[Math.max(index - 1, 0)].id)
        }
        sx={{
          backgroundColor: "#ebe4d2",
          color: "#333",
          border: "2px solid #818977",
          "&:hover": {
            backgroundColor: "#d3cebc",
            borderColor: "#C08936",
          },
          "&:disabled": {
            opacity: 0.4,
            color: "#666",
            borderColor: "#ccc",
          },
        }}
      >
        <ArrowBackIosNewIcon />
      </IconButton>

      <IconButton
        disabled={index === excursiones.length - 1}
        onClick={() =>
          scrollToSection(
            excursiones[Math.min(index + 1, excursiones.length - 1)].id
          )
        }
        sx={{
          backgroundColor: "#C08936",
          color: "#fff",
          border: "2px solid transparent",
          "&:hover": {
            backgroundColor: "#a8722d",
          },
          "&.Mui-disabled": {
            backgroundColor: "#ccc",
            color: "#666",
          },
        }}
      >
        <ArrowForwardIosIcon />
      </IconButton>
    </>
  ) : (
    <>
      <Button
        variant="outlined"
        disabled={index === 0}
        onClick={() =>
          scrollToSection(excursiones[Math.max(index - 1, 0)].id)
        }
        sx={{
          backgroundColor: "#ebe4d2",
          color: "#333",
          borderColor: "#818977",
          fontWeight: "bold",
          letterSpacing: "0.05em",
          "&:hover": {
            backgroundColor: "#d3cebc",
            borderColor: "#C08936",
          },
          "&:disabled": {
            opacity: 0.4,
            color: "#666",
            borderColor: "#ccc",
          },
        }}
      >
        <ArrowBackIosNewIcon sx={{ mr: 1 }} /> Anterior
      </Button>

      <Button
        variant="contained"
        disabled={index === excursiones.length - 1}
        onClick={() =>
          scrollToSection(
            excursiones[Math.min(index + 1, excursiones.length - 1)].id
          )
        }
        startIcon={<ArrowForwardIosIcon />}
        sx={{
          backgroundColor: "#C08936",
          color: "#fff",
          fontWeight: "bold",
          letterSpacing: "0.1rem",
          px: 3,
          py: 1.2,
          "&:hover": {
            backgroundColor: "#a8722d",
          },
          "&.Mui-disabled": {
            backgroundColor: "#ccc",
            color: "#666",
          },
        }}
      >
        Siguiente
      </Button>
    </>
  )}
</Box>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}

export default ExcursionesPage;
